import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

const FeatureAllInOne = () => {
    return (
        <section className="py-24 w-full">
            <div className="container mx-auto px-4 md:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
                    <div className="relative pr-8">
                        {/* Green Background Card */}
                        <div className="bg-optibiz-green dark:bg-optibiz-green/90 rounded-[3rem] p-8 md:p-12 relative overflow-hidden shadow-2xl group">
                            <div className="relative z-10 bg-white dark:bg-gray-800 rounded-[2rem] overflow-hidden shadow-lg transform rotate-[-2deg] group-hover:rotate-0 transition-transform duration-500 border border-gray-100 dark:border-gray-700">
                                <img
                                    src="https://images.pexels.com/photos/7658399/pexels-photo-7658399.jpeg"
                                    alt="Team Collaboration"
                                    className="w-full h-64 object-cover"
                                />
                                <div className="p-6">
                                    <div className="flex items-center gap-4 mb-4">
                                        <div className="flex -space-x-3">
                                            {[1, 2, 3].map((i) => (
                                                <div key={i} className="w-10 h-10 rounded-full border-2 border-white dark:border-gray-700 overflow-hidden">
                                                    <img src={`https://i.pravatar.cc/150?u=${i + 10}`} alt="User" className="w-full h-full object-cover" />
                                                </div>
                                            ))}
                                            <div className="w-10 h-10 rounded-full border-2 border-white dark:border-gray-700 bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-xs font-bold text-gray-500 dark:text-gray-400">+5</div>
                                        </div>
                                        <div className="text-sm font-bold text-gray-600 dark:text-gray-300">Team Members</div>
                                    </div>
                                    <div className="h-2 bg-gray-100 dark:bg-gray-700 rounded-full w-full overflow-hidden">
                                        <div className="h-full bg-optibiz-green w-3/4 rounded-full"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Decorative Circles */}
                            <div className="absolute top-10 right-10 w-32 h-32 bg-white/10 dark:bg-white/5 rounded-full blur-2xl"></div>
                            <div className="absolute bottom-10 left-10 w-40 h-40 bg-white/10 dark:bg-white/5 rounded-full blur-2xl"></div>
                        </div>
                    </div>

                    <div>
                        <div className="inline-block bg-optibiz-green/10 dark:bg-optibiz-green/20 text-optibiz-green text-xs font-bold px-3 py-1 rounded-full mb-4">
                            Features
                        </div>
                        <h2 className="text-4xl md:text-5xl font-extrabold text-tasktide-dark dark:text-white mb-8 leading-tight">
                            All-in-One Business Management for African Enterprises
                        </h2>
                        <p className="text-gray-500 dark:text-gray-400 text-md mb-10  leading-relaxed">
                            From CRM and HRM to POS and Education Management, OptiBiz Suite provides everything your business needs. One integrated platform eliminates silos and connects your entire organization.
                        </p>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeatureAllInOne;
